import {AlteraPessoa} from "./altera-pessoa";

export class PessoaDetalhes extends AlteraPessoa{
  tipoDocumentoDescricao: string;
}
